import { db } from '../firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

// Client-side mirror of firestore.rules' 2000-char cap, so an over-length
// message is rejected instantly instead of round-tripping to Firestore first.
export const MAX_FEEDBACK_MESSAGE_LENGTH = 2000;

// Create-only mailbox -- no matching fetch function, since the app never
// reads this collection back (see firestore.rules' feedback block).
// `email` is the account's real Firebase Auth sign-up email (not anything
// Hero-scoped), stored so the sendContactEmail Cloud Function can set it as
// the outgoing notification's Reply-To -- without it, a reply in Gmail has
// no real address to go to.
export const submitFeedback = async (ownerUserId, profileId, heroName, message, email) => {
  try {
    await addDoc(collection(db, 'feedback'), {
      ownerUserId,
      profileId: profileId || null,
      heroName: heroName || null,
      message,
      email: email || null,
      createdAt: serverTimestamp()
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
